import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { formatNumber } from 'src/utils/format';
import { useStyles } from './useStyles';

export const SimilarityLabel = memo(({ className, basedOnValue, loading }) => {
  const styles = useStyles();

  return (
    <Typography
      className={cx(styles.root, className)}
      component="span"
    >
      {loading ? (
        <Skeleton
          className={styles.skeleton}
          width="180px"
        />
      ) : (
        <Typography
          component="span"
          className={styles.text}
        >
          Comparing to {formatNumber(basedOnValue || 0)} similar copy variations
        </Typography>
      )}
    </Typography>
  );
});

SimilarityLabel.propTypes = {
  className: PropTypes.string,
  basedOnValue: PropTypes.number,
  loading: PropTypes.bool,
};

SimilarityLabel.defaultProps = {
  className: null,
  basedOnValue: 0,
  loading: false,
};
